import { styled, Typography } from '@mui/material';

export const CollapseLabel = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;

  font-weight: 500;
`;
